import {
  Fragment,
  startTransition,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from "react";
import parse from "html-react-parser";
import useFetch from "../../../hook/useFetch";
import useFilter from "../../../hook/useFilter";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import ToggleButton from "../../ToggleButton";
import { Link, redirect, useNavigate } from "react-router-dom";
import { notificationActions } from "../../../store/notification-slice";
import InfoIcon from "../../InfoIcon";
import { faAdd, faClose, faPhotoFilm } from "@fortawesome/free-solid-svg-icons";

import Modal from "../../Modal";
import { backdropActions } from "../../../store/backdrop-slice";
import Gallery from "../../gallery";
import { DashboardPagination } from "../../DashboardPagination";

const firstValue = (...values) => values.find(value => (
  (typeof value === "string" || typeof value === "number") && String(value).trim() !== ""
));

const activationStatus = (license, activation) => {
  if (activation.revoked_at) return "Deactivated";
  if (Number(license.status) === 2) return "Expired";
  if (Number(license.status) === 1) return "Active";
  return "Inactive";
};

export default function NewProduct({ product }) {

  
  let componentReducer = (state, action) => {
    switch (action.type) {
      case "title":
        return { ...state, title: action.data };

      case "app_code":
        return { ...state, app_code: action.data };

      case "ldescription":
        return { ...state, ldescription: action.data };
      case "sdescription":
        return { ...state, sdescription: action.data };
      case "start":
        return { ...state, start: action.data };
      case "end":
        return { ...state, end: action.data };
      case "image":
        return {
          ...state,
          image: action.data,
          imagepreview: URL.createObjectURL(action.data),
        };
      case "video":
        return {
          ...state,
          video: action.data,
          videopreview: URL.createObjectURL(action.data),
          video_identifier: null,
        };
      case "price":
        return { ...state, price: action.data };
      case "currency":
        return { ...state, currency: action.data };
      case "addtag":
        if (state.tags.indexOf(action.data) !== -1) {
          return state;
        }
        return { ...state, tags: [...state.tags, action.data] };

      case "removetag":
        let updatedtags = state.tags;
        updatedtags = updatedtags.filter((tag) => tag !== action.data);

        return { ...state, tags: updatedtags };

      case "active":
        return { ...state, active: action.data };

      case "ptype":
        return { ...state, ptype: action.data };
      case "imagepreview":
        return { ...state, imagepreview: action.data };
      case "identifier":
        return { ...state, identifier: action.data };
      case "videopreview":
        return { ...state, videopreview: action.data };
      case "video_identifier":
        return { ...state, video_identifier: action.data };

      case 'validity_mode':
        return { ...state, validity_mode: action.data }

      case 'validity_unit':
        return { ...state, validity_unit: action.data }
      case 'max_instances':
        return { ...state, max_instances: action.data }

      case 'validity_value':
        return { ...state, validity_value: action.data }
    }
  };

  const [componentState, componentDispatch] = useReducer(componentReducer, {
    title: product ? product.title : null,
    app_code: product ? product.app_code : "",
    ldescription: product ? product.description : null,
    sdescription: product ? product.short_description : null,
    start: product ? product.start : null,
    end: product ? product.end : null,
    image: null,
    video: null,
    price: product ? product.price : null,
    currency: product ? product.currency : null,
    tags: product ? product.tags : [],
    active: product ? product.active : 1,
    ptype: product ? product.product_type_id : null,

    imagepreview: product ? `${product.image}` : null,
    identifier: product && product.identifier ? product.identifier : null,
    videopreview: product ? product.video : null,
    video_identifier: product && product.video_identifier ? product.video_identifier : null,
    // 0 is the valid UNLIMITED mode, so do not fall back based on truthiness.
    validity_mode: product?.validity_mode ?? 2,
    validity_unit: product?.validity_unit ?? 3,
    validity_value: product?.validity_value ?? 1,
    max_instances: product?.max_instances ?? 1,
  });

  const { post, error, get, update } = useFetch();

  const [tags, setTags] = useState();

  const [licenses, setLicenses] = useState([]);
  const [licenseSearch, setLicenseSearch] = useState("");
  const [licenseStatus, setLicenseStatus] = useState("all");
  const [licensePage, setLicensePage] = useState(0);
  const [licensePageSize, setLicensePageSize] = useState(10);

  const [currencies, setCurrencies] = useState();

  const [ptypes, setPtypes] = useState();

  const [images, setImages] = useState();

  const [validityModes,setValidityModes] = useState(product && product.potential_validity_mode)
  const [validityUnits,setValidityUnits] = useState(product && product.potential_validity_unit)


  const { convertToArray } = useFilter();



  let dispatch = useDispatch();

  let navigate = useNavigate();

  const modalReducer = (state, action) => {
    switch (action.type) {
      case "show":
        return { ...state, show: !state.show };

      case "data":
        return { ...state, data: action.data };
    }
  };

  const [modalstate, modaldispatch] = useReducer(modalReducer, {
    show: false,
    data: null,
  });

  useEffect(() => {
    get(`/admin/tags`, null, null, (data) => {
      data = convertToArray(data);
      let update = data;
      if (componentState.tags) {
        update = data.filter(
          (tag) => componentState.tags.indexOf(tag.tag) === -1
        );
      }
      setTags(update);
    });

    get(`/admin/currencies`, null, null, (data) => {
      data = convertToArray(data);
      setCurrencies(data);
    });

    get(`/admin/producttypes`, null, null, (data) => {
      data = convertToArray(data);
      setPtypes(data);
      if (!componentState.ptype) {
        componentDispatch({
          type: "ptype",
          data: data[0].id,
        });
      }
    });


    if(!validityModes || validityUnits){
         get(`/admin/product_validity_props`, null, null, (data) => {
     setValidityModes(data.potential_validity_mode)
     setValidityUnits(data.potential_validity_unit)
    });
    }

  }, []);

  const loadLicenses = () => {
    if (!product?.id) return;
    get("/admin/product-licenses", { product_id: product.id }, null, (data) => {
      setLicenses(Array.isArray(data) ? data : []);
    });
  };

  useEffect(() => {
    loadLicenses();
  }, [product?.id]);

  const licenseRows = useMemo(() => licenses.flatMap(license => (license.activations || []).map(activation => ({
    license,
    activation,
    status: activationStatus(license, activation),
    activatedBy: firstValue(
      activation.activated_by_name,
      activation.activated_by_email,
      activation.activated_by?.name,
      activation.activated_by?.email,
      activation.activated_by,
      activation.user_name,
      activation.user_email,
      license.customer_name,
      license.customer_email
    ) || "—",
    deactivatedBy: firstValue(
      activation.deactivated_by_name,
      activation.deactivated_by_email,
      activation.deactivated_by?.name,
      activation.deactivated_by?.email,
      activation.deactivated_by,
      activation.revoked_by_name,
      activation.revoked_by_email,
      activation.revoked_by?.name,
      activation.revoked_by?.email,
      activation.revoked_by
    ) || "—",
  }))), [licenses]);

  const filteredLicenseRows = useMemo(() => {
    const search = licenseSearch.trim().toLocaleLowerCase();

    return licenseRows.filter(row => {
      if (licenseStatus !== "all" && row.status.toLocaleLowerCase() !== licenseStatus) return false;
      if (!search) return true;

      return [
        row.license.customer_name,
        row.license.customer_email,
        row.license.license_key,
        row.license.token,
        row.activation.site_url,
        row.activatedBy,
        row.deactivatedBy,
      ].some(value => String(value ?? "").toLocaleLowerCase().includes(search));
    });
  }, [licenseRows, licenseSearch, licenseStatus]);

  useEffect(() => {
    setLicensePage(0);
  }, [licenseSearch, licenseStatus, licensePageSize, licenses]);

  const licensePageCount = Math.max(1, Math.ceil(filteredLicenseRows.length / licensePageSize));
  const currentLicensePage = Math.min(licensePage, licensePageCount - 1);
  const pagedLicenseRows = filteredLicenseRows.slice(
    currentLicensePage * licensePageSize,
    (currentLicensePage + 1) * licensePageSize
  );

  let currencyOptions = [];

  if (currencies) {
    Object.keys(currencies).forEach((key) => {
      currencyOptions.push(
        <option key={key} value={key}>
          {currencies[key]}
        </option>
      );
    });
  }

  let validityModeOptions = []

  if (validityModes) {
    Object.keys(validityModes).forEach((key) => {
      validityModeOptions.push(
        <option key={key} value={key}>
          {validityModes[key]}
        </option>
      );
    });
  }

  let validityUnitOptions = []

  if (validityUnits) {
    Object.keys(validityUnits).forEach((key) => {
      validityUnitOptions.push(
        <option key={key} value={key}>
          {validityUnits[key]}
        </option>
      );
    });
  }

  return (
    <div className="edit-container">
      {error && (
        <div className="alert bg-danger ">
          <p>{parse(error)}</p>
        </div>
      )}
      <form
        className="edit-form bg-white grid-container-2-col"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        onSubmit={(e) => {
          e.preventDefault();

          if (product) {
            update(
              `/admin/product?id=${product.id}`,
              componentState,
              (data) => {
                dispatch(
                  notificationActions.setNotification({
                    status: false,
                    message: data,
                  })
                );
              },
              (data) => {
                dispatch(
                  notificationActions.setNotification({
                    status: true,
                    message: data,
                  })
                );

                navigate("/admin/products", {
                  state: {
                    refetch: true,
                  },
                });
              }
            );

            return;
          }

          post(
            `/admin/product`,
            componentState,
            (data) => {
              dispatch(
                notificationActions.setNotification({
                  status: false,
                  message: data,
                })
              );
            },
            (data) => {
              dispatch(
                notificationActions.setNotification({
                  status: true,
                  message: data,
                })
              );

              navigate("/admin/products", {
                state: {
                  refetch: true,
                },
              });
            }
          );
        }}
      >
        <div className="left-col">
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="title"
              defaultValue={componentState.title}
              onInput={(e) => {
                componentDispatch({
                  type: "title",
                  data: e.target.value,
                });
              }}
              required
            />
          </div>

          <div className="form-group">
            <label>App Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. RSO WP PLUGIN PRO"
              defaultValue={componentState.app_code}
              pattern="[A-Za-z0-9 _.\-]+"
              maxLength={100}
              onInput={(e) => {
                componentDispatch({
                  type: "app_code",
                  data: e.target.value,
                });
              }}
            />

            <small className="text-muted">
              Stable technical identifier for licenses; do not change after sales.
            </small>
          </div>

          <div className="form-group">
            <label>Allowed installations per license</label>
            <input
              type="number"
              min="1"
              step="1"
              className="form-control"
              value={componentState.max_instances}
              onChange={(e) => componentDispatch({ type: "max_instances", data: e.target.value })}
              required
            />
            <small className="text-muted">Number of WordPress sites that may use one newly issued license.</small>
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              className="form-control"
              placeholder="long description"
              defaultValue={componentState.ldescription}
              onInput={(e) => {
                componentDispatch({
                  type: "ldescription",
                  data: e.target.value,
                });
              }}
            />
          </div>

          <div className="form-group">
            <label>ShortDescription</label>
            <textarea
              className="form-control"
              placeholder="short description"
              defaultValue={componentState.sdescription}
              onInput={(e) => {
                componentDispatch({
                  type: "sdescription",
                  data: e.target.value,
                });
              }}
            />
          </div>

          <div className="form-group">
            <label>Image</label>
            <input
              type="file"
              accept=".jpg, .jpeg, .png"
              className="form-control"
              defaultValue={componentState.image}
              onChange={(e) => {
                if (!e.target.files[0]) {
                  return;
                }
                console.log(e.target.files)
                componentDispatch({
                  type: "image",
                  data: e.target.files[0],
                });
              }}
            />
          </div>

          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={() => {
              get(`/admin/images`, null, null, (data) => {
                data = convertToArray(data);
                setImages(data);
                modaldispatch({
                  type: "data",
                  data: {
                    body: (
                      <Gallery
                        images={data}
                        onDoubleClick={(image) => {
                          componentDispatch({
                            type: "identifier",
                            data: image.identifier,
                          });
                          componentDispatch({
                            type: "imagepreview",
                            data: image.path,
                          });
                          modaldispatch({
                            type: "show",
                          });
                          dispatch(backdropActions.toggleBackdrop());
                        }}
                      />
                    ),
                  },
                });
                modaldispatch({
                  type: "show",
                });
                dispatch(backdropActions.toggleBackdrop());
              });
            }}
          >
            <InfoIcon icon={faPhotoFilm} size="xl" />
            GALLERY
          </button>

          {componentState.imagepreview && (
            <div className="form-group">
              <img
                className="card-img-top"
                src={`${componentState.imagepreview}`}
                alt={componentState.title}
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          )}

          <div className="form-group mt-3">
            <label>Video</label>
            <input
              type="file"
              accept="video/mp4,video/webm,video/ogg,.mp4,.webm,.ogv"
              className="form-control"
              onChange={(e) => {
                if (!e.target.files[0]) {
                  return;
                }
                componentDispatch({ type: "video", data: e.target.files[0] });
              }}
            />

            <small className="text-muted">MP4, WebM, or Ogg; maximum 100 MiB.</small>
          </div>

          <button
            className="btn btn-outline-secondary mt-2"
            type="button"
            onClick={() => {
              get(`/admin/videos`, null, null, (data) => {
                data = convertToArray(data);
                setImages(data);
                modaldispatch({
                  type: "data",
                  data: {
                    body: (
                      <Gallery
                        images={data}
                        onDoubleClick={(video) => {
                          componentDispatch({ type: "video_identifier", data: video.identifier });
                          componentDispatch({ type: "videopreview", data: video.path });
                          modaldispatch({ type: "show" });
                          dispatch(backdropActions.toggleBackdrop());
                        }}
                      />
                    ),
                  },
                });
                modaldispatch({ type: "show" });
                dispatch(backdropActions.toggleBackdrop());
              });
            }}
          >
            <InfoIcon icon={faPhotoFilm} size="xl" />
            VIDEO GALLERY
          </button>

          {componentState.videopreview && (
            <div className="form-group mt-3">
              <video
                src={componentState.videopreview}
                controls
                preload="metadata"
                style={{ width: "100%", maxHeight: "420px" }}
              >
                Your browser does not support video playback.
              </video>
            </div>
          )}
        </div>
        <div className="right-col">
          <div className="form-group">
            <label>Start</label>
            <input
              type="date"
              className="form-control"
              defaultValue={componentState.start}
              onInput={(e) => {
                componentDispatch({
                  type: "start",
                  data: e.target.value,
                });
              }}
            />
          </div>

          <div className="form-group">
            <label>End</label>
            <input
              type="date"
              className="form-control"
              defaultValue={componentState.end}
              onInput={(e) => {
                componentDispatch({
                  type: "end",
                  data: e.target.value,
                });
              }}
            />
          </div>

          <div className="form-group">
            <label>Price</label>
            <input
              type="number"
              min={0}
              className="form-control"
              placeholder="price"
              defaultValue={componentState.price}
              onInput={(e) => {
                componentDispatch({
                  type: "price",
                  data: e.target.value,
                });
              }}
            />
          </div>

          <div className="form-group">
            <ToggleButton
              onToggle={(e) => {
                componentDispatch({
                  type: "active",
                  data: !componentState.active,
                });
              }}
              id="productactive"
              label="Active"
              defaultChecked={componentState.active}
            />
          </div>

          {ptypes && (
            <div className="form-group">
              <div className="grid-container-2-col">
                <select
                  className="form-control"
                  defaultValue={componentState.ptype}
                  onChange={(e) => {
                    componentDispatch({
                      type: "ptype",
                      data: e.target.value,
                    });
                  }}
                >
                  <option value="">ProductType</option>
                  {ptypes.map((ptype) => (
                    <option key={ptype.id} value={ptype.id}>
                      {ptype.title}
                    </option>
                  ))}
                </select>
                <Link
                  className="btn btn-outline-secondary"
                  to="/admin/producttype"
                  state={{
                    redirect: "/admin/newproduct",
                  }}
                >
                  NewProductType
                </Link>
              </div>
            </div>
          )}
          <div className="form-group">
            <input
              className="form-control"
              placeholder="enter new tag press Enter"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  componentDispatch({
                    type: "addtag",
                    data: e.target.value,
                  });
                }
              }}
              type="text"
            />
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {componentState.tags &&
              componentState.tags.map((tag) => (
                <div
                  key={tag}
                  className="shadow rounded"
                  style={{
                    width: 100,
                    padding: 5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {tag}

                  <InfoIcon
                    size="xs"
                    icon={faClose}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      componentDispatch({
                        type: "removetag",
                        data: tag,
                      });

                      let update = [...tags, { tag: tag }];

                      setTags(update);
                    }}
                  />
                </div>
              ))}
          </div>

          {tags && (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {tags.map((tag) => (
                <div
                  key={tag.tag}
                  className="shadow rounded"
                  style={{
                    width: 100,
                    padding: 5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {tag.tag}

                  <InfoIcon
                    size="xs"
                    style={{ cursor: "pointer" }}
                    icon={faAdd}
                    onClick={() => {
                      componentDispatch({
                        type: "addtag",
                        data: tag.tag,
                      });

                      let update = tags.filter((utag) => utag.tag !== tag.tag);

                      setTags(update);
                    }}
                  />
                </div>
              ))}
            </div>
          )}

          {currencies && (
            <div className="form-group">
              <select
                className="form-control"
                defaultValue={componentState.currency}
                onChange={(e) => {
                  componentDispatch({
                    type: "currency",
                    data: e.target.value,
                  });
                }}
              >
                <option value="">Currency</option>
                {currencyOptions}
              </select>
            </div>
          )}
          {validityModes && (
            <div className="form-group">
              <select
                className="form-control"
                defaultValue={componentState.validity_mode}
                onChange={(e) => {
                  componentDispatch({
                    type: "validity_mode",
                    data: e.target.value,
                  });
                }}
              >
                <option value="">Validity mode</option>
                {validityModeOptions}
              </select>
            </div>
          )}

          {validityUnits && (
            <div className="form-group">
              <select
                className="form-control"
                defaultValue={componentState.validity_unit}
                onChange={(e) => {
                  componentDispatch({
                    type: "validity_unit",
                    data: e.target.value,
                  });
                }}
              >
                <option value="">Validity unit</option>
                {validityUnitOptions}
              </select>
            </div>
          )}

          <input type="number" className="form-control" value={componentState.validity_value} min={1} onChange={(e) => {
            componentDispatch({
              type: "validity_value",
              data: e.target.value,
            });
          }} />

          <button type="submit" className="btn btn-primary">
            {product ? "UPDATE" : "REGISTER"}
          </button>
        </div>
      </form>

      {product && (
        <section className="mt-4 license-history">
          <div className="license-history__heading">
            <div>
              <h3>License installation history</h3>
              <p className="text-muted mb-0">Disconnect or reconnect individual WordPress installations. The customer's order entitlement is managed separately in the user view.</p>
            </div>
            {licenseRows.length > 0 && <span className="license-history__count">{filteredLicenseRows.length} of {licenseRows.length}</span>}
          </div>
          {licenseRows.length === 0 ? (
            <p className="text-muted">No licenses or activated domains yet.</p>
          ) : (
            <>
              <div className="license-history__filters">
                <div>
                  <label htmlFor="license-history-search" className="form-label">Search</label>
                  <input
                    id="license-history-search"
                    type="search"
                    className="form-control"
                    value={licenseSearch}
                    placeholder="Name, email, domain or license"
                    onChange={event => setLicenseSearch(event.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="license-history-status" className="form-label">Status</label>
                  <select id="license-history-status" className="form-select" value={licenseStatus} onChange={event => setLicenseStatus(event.target.value)}>
                    <option value="all">All statuses</option>
                    <option value="active">Active</option>
                    <option value="deactivated">Deactivated</option>
                    <option value="expired">Expired</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="license-history-page-size" className="form-label">Per page</label>
                  <select id="license-history-page-size" className="form-select" value={licensePageSize} onChange={event => setLicensePageSize(Number(event.target.value))}>
                    {[10, 25, 50, 100].map(size => <option value={size} key={size}>{size}</option>)}
                  </select>
                </div>
              </div>

              {filteredLicenseRows.length === 0 ? (
                <p className="license-history__empty">No activations match the selected filters.</p>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table license-history__table">
                      <thead><tr><th>Customer</th><th>Status</th><th>Activated by</th><th>Deactivated by</th><th>Expires</th><th>Limit</th><th>Domain</th><th>Activated at</th><th>Deactivated at</th><th>Last seen</th><th>Actions</th></tr></thead>
                      <tbody>
                        {pagedLicenseRows.map(({ license, activation, status, activatedBy, deactivatedBy }) => {
                          const statusClass = status === "Active" ? "bg-success" : (status === "Expired" ? "bg-danger" : "bg-secondary");
                          const canDeactivate = !activation.revoked_at && Number(license.status) === 1;
                          const canReactivate = Boolean(activation.revoked_at) && Number(license.status) === 1;
                          const updateActivation = active => update(
                            "/admin/license-activation",
                            { activation_id: activation.id, active: active ? 1 : 0 },
                            message => dispatch(notificationActions.setNotification({ message, status: false })),
                            () => {
                              loadLicenses();
                              dispatch(notificationActions.setNotification({
                                message: active ? "License activation restored" : "License activation deactivated",
                                status: true,
                              }));
                            }
                          );

                          return <tr key={activation.id}>
                            <td>{firstValue(license.customer_name, license.customer_email) || "—"}</td>
                            <td><span className={`badge ${statusClass}`}>{status}</span></td>
                            <td>{activatedBy}</td>
                            <td>{deactivatedBy}</td>
                            <td>{license.expires_at || "Unlimited"}</td>
                            <td>{license.max_instances}</td>
                            <td>{activation.site_url}</td>
                            <td>{activation.activated_at || "—"}</td>
                            <td>{activation.revoked_at || "—"}</td>
                            <td>{activation.last_seen_at || "—"}</td>
                            <td>{canDeactivate
                              ? <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => updateActivation(false)}>Deactivate installation</button>
                              : (canReactivate
                                ? <button type="button" className="btn btn-sm btn-outline-success" onClick={() => updateActivation(true)}>Reactivate installation</button>
                                : "—")}</td>
                          </tr>;
                        })}
                      </tbody>
                    </table>
                  </div>
                  <DashboardPagination
                    totalPages={licensePageCount}
                    currentPage={currentLicensePage}
                    onPageChange={setLicensePage}
                    label="Lizenzverlauf Seitennavigation"
                  />
                </>
              )}
            </>
          )}
        </section>
      )}

      {images && modalstate.show && modalstate.data && (
        <div className="gallery">
          <Modal
            body={modalstate.data.body}
            hideCopy={true}
            onClose={() => {
              modaldispatch({
                type: "show",
              });
              dispatch(backdropActions.toggleBackdrop());
            }}
          />
        </div>
      )}
    </div>
  );
}
